import axios from 'axios'
import type { PeopleInvitedToOrgResponse } from 'src/models/people.models'
import { getResponseData, normalizeQueryError } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'
import type { PostPeopleInvitesRequest } from 'src/requests/postPeopleInvites.request'

export const postInviteToOrganization = async (
  organizationId: string,
  body: Partial<PostPeopleInvitesRequest>,
): Promise<PeopleInvitedToOrgResponse> => {
  if (!organizationId) {
    // Rejects in the same QueryError shape as every getResponseData failure, so
    // the mutation's declared error type holds. `error` is user-rendered copy
    // (parseBackendErrors -> postInvitesTopLevelError -> ErrorList); the
    // diagnostic rides on `code`.
    throw normalizeQueryError({
      error: 'Sorry, something went wrong. Please try again later.',
      code: 'MISSING_ORGANIZATION_ID',
    })
  }

  return getResponseData(
    axios.post<PeopleInvitedToOrgResponse>(
      `/organizations/${organizationId}/invite`,
      {
        emails: body.emails,
        role: body.role,
        bookkeeperAccountVisibilityType: body.bookkeeperAccountVisibilityType,
        bookkeeperAccounts: body.bookkeeperAccounts,
        cardManagerAccounts: body.cardManagerAccounts,
      },
      getRequestConfig(RequestConfig.Default),
    ),
  )
}
